@import "../use-bootstrap-mixins";

.underline {
  border-bottom: 2px solid #000;
  line-height: normal;
}

.title {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 10px !important;
  width: 100%;
  font-size: 22px;

  @include media-breakpoint-up(sm) {
    font-size: 38px;
    margin-bottom: 24px !important;
  }
}

.mobile {
  display: block !important;

  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}

.desktop {
  display: none !important;

  @include media-breakpoint-up(lg) {
    display: block !important;
    margin-bottom: 35px;
  }
}

.container {
  @include media-breakpoint-up(lg) {
    display: flex;
    justify-content: center;
  }

  .card_container {
    @include media-breakpoint-up(lg) {
      border-radius: 14px;
      width: 407px;
      max-height: 357px;
      position: initial !important;
    }
  }
}

.card {
  z-index: 5 !important;
  border-radius: 14px;
  flex-grow: 1;
  padding: 30px 23px;
  color: #fff;

  @include media-breakpoint-up(lg) {
  }

  .header {
    display: flex;
    justify-content: space-between;

    .first {
      text-align: left;
      flex: 1;

      span {
        font-size: 18px;
        font-weight: 400;
        margin: 0;
      }

      span {
        font-size: 11px;
        font-weight: 400;
        opacity: 0.7;
      }
    }

    .last {
      text-align: right;

      span {
        font-size: 18px;
        font-weight: 400;
        margin: 0;
        text-align: right !important;
      }

      .pricing_desc {
        display: flex;

        span {
          font-size: 11px;
          font-weight: 400;
          opacity: 0.7;
        }

        .savings_badge {
          background-color: $shade2;
          padding: 1px 4px;
          border-radius: 40%;
          opacity: 1 !important;
          margin-left: 4px;
        }
      }
    }
  }

  .description {
    display: flex;
    margin-top: 22px;
    margin-bottom: 32px;
    flex-wrap: wrap;
    width: 100%;

    .inclusion {
      width: 50%;

      .tick {
        svg {
          width: 13px;
          height: 9px;
          margin-right: 13px;
        }
      }

      .text {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .customise_booking {
    font-size: 16px;
    font-weight: 500;
    margin-top: 22px;
    margin-bottom: 13px;
  }

  .buttons {
    display: flex;
    width: 100%;
    gap: 14px;
    overflow: hidden;
  }
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 24px;
  overflow: hidden;

  @include media-breakpoint-up(lg) {
    display: flex !important;
  }

  button {
    max-width: 205px;
    width: 100%;
  }
}

.upsize_motion {
  span {
    margin-top: 23px;
  }

  span {
    margin-bottom: 12px;
  }

  span,
  span {
    display: block;
    text-align: center;
  }

  @include media-breakpoint-up(lg) {
    display: flex;
    align-items: center;
    width: 487px;

    span {
      margin-top: 0;
      margin-left: 25px;
      margin-right: 25px;
    }

    span {
      display: none;
    }
  }
}

.open_card {
  border-radius: 14px 14px 0 0 !important;
  height: 100%;
  color: white;
}

.upsize_card {
  border-radius: 14px;
  padding: 21px;
  width: 100%;
  margin: 0 auto;
  transition: all 0.4s;

  @include media-breakpoint-up(lg) {
  }

  .descriptor {
    display: flex;
    margin-bottom: 36px;
    align-items: center;
    img {
      height: 75px;
    }
    .details {
      flex-grow: 1;
      span {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        text-align: left;
      }
      label {
        font-size: 10px;
      }
    }
    .pricing {
      span {
        margin: 0;
        font-size: 18px;
      }
      label {
        font-size: 10px;
      }
    }
  }

  .picture_container {
    max-width: 200px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }
}
